import { VerseText } from "./VerseText";
import { VerseActions } from "./VerseActions";

interface VerseContainerProps {
  verse: {
    text: string;
    reference: string;
    version: string;
  };
  onNextVerse: () => void;
  showRegisterButton: boolean;
  onRegisterClick: () => void;
}

export function VerseContainer({ 
  verse, 
  onNextVerse, 
  showRegisterButton, 
  onRegisterClick 
}: VerseContainerProps) {
  return (
    <div className="flex-1 flex items-center justify-center w-full px-4 mt-4 pb-20">
      <div className="w-full max-w-2xl space-y-8">
        <VerseText 
          text={verse.text} 
          reference={verse.reference} 
          version={verse.version}
        />
        <div className="space-y-4">
          <VerseActions 
            onNextVerse={onNextVerse}
            showRegisterButton={showRegisterButton}
            onRegisterClick={onRegisterClick}
          />
        </div>
      </div>
    </div>
  );
}